<template>
  <b-overlay :show="!link">
    <div v-if="link">
      <b-embed
        type="iframe"
        aspect="16by9"
        :src="link"
        allowfullscreen
      />
    </div>
  </b-overlay>

</template>

<script>
import { BEmbed, BOverlay } from 'bootstrap-vue'

export default {
  components: {
    BEmbed,
    BOverlay,
  },
  data() {
    return {
      link: null,
    }
  },
  mounted() {
    this.getVote()
  },
  methods: {
    getVote() {
      this.$http.get(`my-votes/${this.$route.params.id}`)
        .then(({ data }) => {
          if (data.status) {
            this.link = data.link
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت نظر با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
  },
}
</script>
